module.exports = __webpack_public_path__ + "static/media/light-divider.f15fe8cd.png";